import { Participant } from "../Participant";
import { User } from "../User";

export type ExamPeriodMonitorUserLogin = {
    loggedInAt: string;
    ipAddress: string;
    proxyIPAdress: string;
    userAgent: string;
    tokenValue: string;
}

export type ExamPeriodMonitorProctoringEvent = {
    id: string;
    eventType: string;
    eventSource: string;
    sessionId: string;
    safeExamBrowserDetected: boolean;
    userAgent: string;
    ipAddress: string;
    details: string;
    dateCreated?: string;
}

export type ExamPeriodMonitor = {
    id: string;
    title: string;
    participant: Participant;
    state: ExamPeriodMonitorState;
    totalScore: number;
    hasPassed: boolean;
    questionTimer?: number;
    groupTimer?: number;
    instanceTimer?: number;
    userExaminee: User;
    percentageOfCompletion: number;
    userLogins: ExamPeriodMonitorUserLogin[];
    proctoringEvents: ExamPeriodMonitorProctoringEvent[];
    sessionCount: number;
    hasMultipleSessions: boolean;
    requiresSafeExamBrowser: boolean;
    hasSafeExamBrowserDetected: boolean;
    hasSafeExamBrowserViolation: boolean;
    lastProctoringEventAt?: string;
    lastExitAt?: string;
}

export enum ExamPeriodMonitorState {
    WaitingForParticipant = 1,
    ParticipantConfirmed = 2,
    NoShow = 3,
    InProgress = 4,
    Paused = 5,
    Excluded = 6,
    Completed = 7,
    Error = 8
}